import axios from 'axios'
import store from './store'
import router from './router'

// 创建axios实例
var Axios = axios.create({
  timeout: 20000, // 10s超时
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
})

Axios.defaults.baseURL = '/api'   // 路由前缀添加 /api

// 请求拦截
Axios.interceptors.request.use(
  // 请求发送前
  config => {
    // 如果TOKEN存在，每个http header都加上TOKEN
    if (store.state.TOKEN) {
      config.headers.Authorization = `token ${store.state.TOKEN}`
    }
    return config
  }
)

// 添加响应拦截器
Axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    return Promise.reject(error.response)
  }
)

export default Axios
